import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOption } from "../../types";
import { useAreAiWorkflowActionsEnabled } from "../reportPost/useAreAiWorkflowActionsEnabled";
import { FormReportComment } from "./FormReportComment";
import type { HistoryDetailViewReportedCommentProps } from "./HistoryDetailViewReportedComment";
import { HistoryDetailViewReportedComment } from "./HistoryDetailViewReportedComment";

export const reportComment: Readonly<
  ActionOption<HistoryDetailViewReportedCommentProps>
> = {
  label: t("settings.workflows.form.actions.ai_agents_report_comment"),
  textLabel: t("settings.workflows.form.actions.ai_agents_report_comment"),
  value: "ai_agents_report_comment",
  group: t("settings.workflows.form.action_groups.ai_agents"),
  leftAddon: <Icon type="16-ai-report" size={16} className="!h-4 !w-4" />,
  formComponent: FormReportComment,
  viewComponent: null,
  historyDetailViewComponent: HistoryDetailViewReportedComment,
  icon: "chat",
  isApplicableToMembersOnly: false,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.HIGHER_TIER_PLAN_ONLY,
  released: useAreAiWorkflowActionsEnabled,
} as const;
